<template lang="pug">
  div.history
    van-dropdown-menu(class="select_box")
      van-dropdown-item(v-model="active", :options="status", @change="changeDrop")
    van-collapse(class="his_collapse", v-model="record")
      van-list(v-model="listLoading", @load="onListLoad", :loading-text="$t('loading')", :finished-text="$t('noMore')", error-text="...", :finished="finished")
        div(class="hst_box van-clearfix", v-for='(item, key) in orderList', :key="key" @click="toChatPage(item)")
          van-collapse-item(class="consume_list")
            template(#icon)
              img(class="consume_icon", :src="item.iconUrl || defaultIcon")
            template(#title)
              p.status {{formatStatus(item.status)}}
              p.title {{item.sessionType == 'p2s' ? item.sessionName : $t('custStaff')}}
              p(v-if="item.messageType==='4'").content {{$t('logRequest')}}
              p(v-else).content {{item.questionSnapshot || ("[" + $t('picture') + "]")}}
            template(#value)
              p.time {{formatDate(item.date, true)}}
          div.van-info.van-info--dot(v-if="item.newMessage!=='0'")
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import {mapActions, mapGetters} from 'vuex';
import Qs from 'qs';

export default {
  name: 'History',
  data($vm){
    return{
      listLoading: false,
      finished: false,
      active: -3,
      pageNumber: 1,
      record: [],
      defaultIcon: require('@/assets/head_icon.png'),
      // status: [
      //   {
      //     text: $vm.$t('all'),
      //     value: -3
      //   },
      //   {
      //     text: $vm.$t('Evaluated'),
      //     value: -2
      //   },
      //   {
      //     text: $vm.$t('end'),
      //     value: -1
      //   },
      //   {
      //     text: $vm.$t('NewReply'),
      //     value: 0
      //   },
      //   {
      //     text: $vm.$t('Pending'),
      //     value: 1
      //   }
      // ],
      orderList: [],
      loadStatus: true
    }
  },
  created(){
    this.getHstQuList(Qs.stringify({
      uid: this.uid,
      deviceId: this.deviceId,
      accessToken: this.token,
      pageLimit: 10,
      pageNumber: this.pageNumber,
      status: this.active,
      phoneModel: this.phoneModel,
      languageCode: this.lang
    }))
  },
  methods:{
    ...mapActions('faq', ['getHstQuList']),
    changeDrop(val){
      this.pageNumber = 1
      this.loadStatus = true
      this.finished = false
      this.orderList = []
      this.getHstQuList(Qs.stringify({
          uid: this.uid,
          deviceId: this.deviceId,
          accessToken: this.token,
          pageLimit: 10,
          pageNumber: 1,
          phoneModel: this.phoneModel,
          status: val,
          languageCode: this.lang
      }))
    },
    toChatPage(val){
        this.$router.push({
            path: '/faq/chat',
            query: val
        })
    },
    onListLoad(){
      if(this.loadStatus){
        return false
      }
      this.loadStatus = true
      this.pageNumber += 1
      this.getHstQuList(Qs.stringify({
        uid: this.uid,
        deviceId: this.deviceId,
        accessToken: this.token,
        pageLimit: 10,
        pageNumber: this.pageNumber,
        phoneModel: this.phoneModel,
        status: this.active,
        languageCode: this.lang
      }))
    }
  },
  computed:{
    ...mapGetters(['uid', 'deviceId', 'token', 'lang', 'phoneModel']),
    ...mapGetters('faq', ['error', 'loadingHst', 'FaqHstQuList']),
    status: $vm => {
      return [
        {
          text: $vm.$t('end'),
          value: -4
        },
        {
          text: $vm.$t('all'),
          value: -3
        },
        {
          text: $vm.$t('Evaluated'),
          value: -2
        },
        {
          text: $vm.$t('w84Eva'),
          value: -1
        },
        {
          text: $vm.$t('NewReply'),
          value: 0
        },
        {
          text: $vm.$t('Pending'),
          value: 1
        }
      ]
    },
    formatDate: (val, key = false) => {
      return (val, key= false) => {
        let payDate = new Date(parseInt(val));
        if(key){
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds() + '    ' + 'UTC+' + (0 - new Date().getTimezoneOffset() / 60);
        } else {
          return payDate.getFullYear() + '-' + (payDate.getMonth() + 1) + '-' + payDate.getDate() + '  ' + payDate.getHours() + ':' + payDate.getMinutes() + ':' + payDate.getSeconds()
        }
      }
    },
    formatStatus: $vm => {
      return val => {
        if(val === '-4'){
          return $vm.$t('end')
        } else if(val === '-3'){
          return $vm.$t('all')
        } else if(val === '-2'){
          return $vm.$t('Evaluated')
        } else if(val === '-1'){
          return $vm.$t('w84Eva')
        } else if(val === '0'){
          return $vm.$t('NewReply')
        } else if(val === '1'){
          return $vm.$t('Pending')
        }
      }
    }
  },
  mounted(){
    this.$watch('loadingHst', val => {
      if(val === 'loadedHst'){
        this.FaqHstQuList.list.map(val => {
          this.orderList.push(val)
        })
        if(this.orderList.length == this.FaqHstQuList.total){
          this.finished = true
        }
        this.loadStatus = false
        this.listLoading = false
      }
    })
  }
}
</script>
<style lang="scss">
.history{ 
  margin: 20px;
  // margin-bottom: -80px;
  // .his_collapse{
  //   height: calc(100vh - 100px);
  // }
  .van-list{
    // overflow: scroll;
    height: 1000px;
    position: relative;
  }
  .van-info--dot{
      width: 12px;
      height: 12px;
  }
  .select_box{
    width: 50%;
    position: relative;
    left: 50%;
    .van-dropdown-menu__bar{
      height: 30px;
    }
  }
  .consume_list{
    margin-top: 10px;
    .van-cell__value{
      position: absolute;
      right: 10px;
      p{
        margin: 0;
      }
    }
    .van-cell__right-icon{
      display: none;
    }
    .van-collapse-item__content{
      p{
        margin: 0;
        padding: 5px 10px;
      }
    }
  }
  .consume_icon{
    height: 60px;
    width: 60px;
    position: relative;
    margin-top: 30px;
  }
  .status{
    margin: 0;
    color: #000;
    margin-left: -70px;
    padding-left: 10px;
    font-weight: bolder;
  }
  .title{
    margin: 0;
    margin-top: 10px;
    color: #000;
    padding-left: 10px;
  }
  .content{
    margin: 0;
    color: #969799;
    padding-left: 10px;
  }
  .time{
    margin: 0;
    font-size: 12px;
    color: #969799;
    padding-left: 10px;
  }
  .hst_box{
      position: relative;
  }
}
</style>